export default __webpack_public_path__ + "static/media/photo-icon.c4181a1d.svg";